var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "keep-alive",
        [
          _c("List", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isShowList,
                expression: "isShowList"
              }
            ],
            ref: "List",
            on: { onHandleEdit: _vm.onHandleEdit }
          })
        ],
        1
      ),
      _c(
        "keep-alive",
        [
          _c("Edit", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isShowEdit,
                expression: "isShowEdit"
              }
            ],
            ref: "Edit",
            on: { handleBlackBtn: _vm.handleBlackBtn }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }